import api from '../lib/api'
import assign from 'lodash.assign'

const name = 'super-paper'

export default {
  name,
  namespaced: true,
  state () {
    return {
      pageNo: 0,
      list: [],
      totalPage: 0,
      start: '',
      prepareLoading: true,
      bannerImage: ''
    }
  },
  getters: {},
  mutations: {
    set (state, data) {
      assign(state, data)
    },
    setList (state, data) {
      state.list = state.list.concat(data)
    }
  },
  actions: {
    async loadMore ({ commit, state, rootState: { route } }) {
      if (!state.prepareLoading) return
      commit('set', { prepareLoading: false})
      const { data } = await api.superPaper.getInfo(state.start, route.query.columnId)()
      commit('setList', data.list)
      commit('set', { totalPage: data.total, start: data.nextStart, prepareLoading: true,  bannerImage: data.bannerImage})
    },
    setBreakPoint ({ commit, state }, { parentIndex, currentIndex, currentTime }) {
      state.list[parentIndex].list[currentIndex].learnLength = currentTime
    }
  }
}
